import {Routes} from '@angular/router';
import {loggedInAuthGuard} from './auth/is-logged-in.guard';
import {adminAuthGuard} from './auth/is-admin.guard';
import {adminOrManagerAuthGuard} from "./auth/is-admin-or-manager.guard";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'conversation-overview',
    pathMatch: 'full',
  },
  {
    path: 'conversations',
    loadComponent: () =>
      import('./conversation/conversation-list.component').then((m) => m.ConversationListComponent),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'evaluation-catalog',
    loadComponent: () => import('./evaluation-catalog/evaluation-catalog.component').then(m => m.EvaluationCatalogComponent),
    canActivate: [loggedInAuthGuard, adminOrManagerAuthGuard],
    canDeactivate: [(component: {dirty: boolean}) => !component.dirty || window.confirm('Discard unsaved definition changes?')],
  },
  {
    path: 'system-prompt',
    loadChildren: () =>
      import('./system-prompt/system-prompt.module').then(
        (m) => m.SystemPromptModule
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'data-labels',
    loadChildren: () =>
      import('./data-label/data-label.module').then(
        (m) => m.DataLabelModule
      ),
    canActivate: [loggedInAuthGuard, adminAuthGuard],
  },
  {
    path: 'ai-model',
    loadChildren: () =>
      import('./ai-model/ai-model.module').then(
        (m) => m.AiModelModule
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'user-list',
    loadComponent: () =>
      import('./user-list/user-list.page').then((m) => m.UserListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'league-list',
    loadComponent: () =>
      import('./league-list/league-list.page').then((m) => m.LeagueListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'club-list',
    loadComponent: () =>
      import('./club-list/club-list.page').then((m) => m.ClubListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'club-list/league/:leagueId',
    loadComponent: () =>
      import('./club-list/club-list.page').then((m) => m.ClubListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'player-list',
    loadComponent: () =>
      import('./player-list/player-list.page').then((m) => m.PlayerListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'player-list/club/:clubId',
    loadComponent: () =>
      import('./player-list/player-list.page').then((m) => m.PlayerListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'match-list',
    loadComponent: () =>
      import('./match-list/match-list-page.component').then((m) => m.MatchListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'welcome-suggestions',
    loadComponent: () =>
      import('./welcome-suggestions/welcome-suggestions.component').then((m) => m.WelcomeSuggestionsComponent),
    canActivate: [loggedInAuthGuard, adminAuthGuard],
  },
  {
    path: 'match-list/club/:clubId',
    loadComponent: () =>
      import('./match-list/match-list-page.component').then((m) => m.MatchListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'match-list/league/:leagueId',
    loadComponent: () =>
      import('./match-list/match-list-page.component').then((m) => m.MatchListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'match-list/player/:playerId',
    loadComponent: () =>
      import('./match-list/match-list-page.component').then((m) => m.MatchListPage),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'product-overview',
    loadChildren: () =>
      import('./product-overview/product-overview.module').then(
        (m) => m.ProductOverviewModule
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'client-overview',
    loadChildren: () =>
      import('./client-overview/client-overview.module').then(
        (m) => m.ClientOverviewModule
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'conversation-overview',
    loadChildren: () =>
      import('./conversation/conversation.module').then(
        (m) => m.ConversationModule
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'knowledge-overview',
    loadChildren: () =>
      import('./knowledge-overview/knowledge-overview.routes').then(
      (m) => m.KNOWLEDGE_OVERVIEW_ROUTES
      ),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'knowledge-assets',
    loadComponent: () =>
      import('./knowledge-asset/knowledge-asset-overview.component').then((m) => m.KnowledgeAssetOverviewComponent),
    canActivate: [loggedInAuthGuard, adminOrManagerAuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
];
